import { useNavigate } from 'react-router-dom'

import { Button } from '@/components'
import { Trans } from '@/components'
import { EmptyView } from '@/components/EmptyView'

interface InsufficientQuotaViewProps {
  link?: string
}

export function InsufficientQuotaView({ link = '/space' }: InsufficientQuotaViewProps) {
  const navigate = useNavigate()

  return (
    <EmptyView
      title={
        <Trans i18nKey="data.insufficientQuotaAvailableTitle">Insufficient quota available</Trans>
      }
      content={
        <Trans i18nKey="data.insufficientQuotaAvailableContent">
          Update your quota settings in Space Management to proceed
        </Trans>
      }
      action={
        <Button type="secondary" onClick={() => navigate(link)}>
          <Trans i18nKey="data.emptyViewActionBtn">Manage Space</Trans>
        </Button>
      }
    />
  )
}
